import axios from "axios";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { List, ListItem, Range, BlockHeader } from "konsta/react";
import { UserContext } from "../lib/UserContext";
import Modal from 'react-modal';


const Questions = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [user, setUser] = useContext(UserContext);

  useEffect(() => {
    user && !user.userId && !user.userName && navigate("/login");
  }, [user, navigate]);

  const [purpose, setPurpose] = useState<number>(0);
  const [purposeScale, setPurposeScale] = useState<number>(0);
  const [connectivity, setConnectivity] = useState<number>(0);
  const [connectivityScale, setConnectivityScale] = useState<number>(0);
  const [transparency, setTransparency] = useState<number>(0);
  const [transparencyScale, setTransparencyScale] = useState<number>(0);
  const [efficiency, setEfficiency] = useState<number>(0);
  const [efficiencyScale, setEfficiencyScale] = useState<number>(0);
  const [impact, setImpact] = useState<number>(0);
  const [impactScale, setImpactScale] = useState<number>(0);
  const [profitability, setProfitability] = useState<number>(0);
  const [profitabilityScale, setProfitabilityScale] = useState<number>(0);
  const [mutualism, setMutualism] = useState<number>(0);
  const [mutualismScale, setMutualismScale] = useState<number>(0);
  const [individualism, setIndividualism] = useState<number>(0);
  const [individualismScale, setIndividualismScale] = useState<number>(0);

  const [purposeConnectivity, setPurposeConnectivity] = useState("");
  const [transparencyEfficiency, setTransparencyEfficiency] = useState("");
  const [impactProfitability, setImpactProfitability] = useState("");
  const [mutualismIndividualism, setMutualismIndividualism] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle,setModalTitle] = useState('');
  const [modalDescription,setModalDescription] = useState('');
  const passValue = (v1:any, v2:any) => {
    setModalTitle(v1);
    setModalDescription(v2);
    setIsModalOpen(true);
  }

  useEffect(() => {
    localStorage.setItem("purpose", JSON.stringify(purpose));
    localStorage.setItem("connectivity", JSON.stringify(connectivity));
    localStorage.setItem("transparency", JSON.stringify(transparency));
    localStorage.setItem("efficiency", JSON.stringify(efficiency));
    localStorage.setItem("impact", JSON.stringify(impact));
    localStorage.setItem("profitability", JSON.stringify(profitability));
    localStorage.setItem("mutualism", JSON.stringify(mutualism));
    localStorage.setItem("individualism", JSON.stringify(individualism));
  }, [
    purpose,
    connectivity,
    transparency,
    efficiency,
    impact,
    profitability,
    mutualism,
    individualism,
  ]);

  const handleNext = () => {
    if (step >= 12) {
      const user_id = user.userId;
      const questions =
        localStorage.getItem("purpose") +
        "," +
        localStorage.getItem("connectivity") +
        "," +
        localStorage.getItem("transparency") +
        "," +
        localStorage.getItem("efficiency") +
        "," +
        localStorage.getItem("impact") +
        "," +
        localStorage.getItem("profitability") +
        "," +
        localStorage.getItem("mutualism") +
        "," +
        localStorage.getItem("individualism");
      const data = { results: questions };
      axios
        .post(`${process.env.REACT_APP_SERVER_URL}/question`, data, {
          params: {
            user_id: user_id,
          },
        })
        .then((response) => {
          console.log("question id",response.data.data.question_id);
          localStorage.setItem("question_id", response.data.data.question_id);
        });
      navigate("/glyph");
    } else {
      setStep(step + 1);
    }
  };

  const calculateParing = () => {
    if (purpose == -2) {
      setConnectivity(connectivity + 1);
      localStorage.setItem("connectivity", JSON.stringify(connectivity + 1));
    }
    if (connectivity == -2) {
      setPurpose(purpose + 1);
      localStorage.setItem("purpose", JSON.stringify(purpose + 1));
    }
    if (transparency == -2) {
      setEfficiency(efficiency + 1);
      localStorage.setItem("efficiency", JSON.stringify(efficiency + 1));
    }
    if (efficiency == -2) {
      setTransparency(transparency + 1);
      localStorage.setItem("transparency", JSON.stringify(transparency + 1));
    }
    if (impact == -2) {
      setProfitability(profitability + 1);
      localStorage.setItem("profitability", JSON.stringify(profitability + 1));
    }
    if (profitability == -2) {
      setImpact(impact + 1);
      localStorage.setItem("impact", JSON.stringify(impact + 1));
    }
    if (mutualism == -2) {
      setIndividualism(individualism + 1);
      localStorage.setItem("individualism", JSON.stringify(individualism + 1));
    }
    if (individualism == -2) {
      setMutualism(mutualism + 1);
      localStorage.setItem("mutualism", JSON.stringify(mutualism + 1));
    }
  };

  const calculateScaling = () => {
    let _purpose = parseInt(localStorage.getItem("purpose"));
    let _connectivity = parseInt(localStorage.getItem("connectivity"));
    let _transparency = parseInt(localStorage.getItem("transparency"));
    let _efficiency = parseInt(localStorage.getItem("efficiency"));
    let _impact = parseInt(localStorage.getItem("impact"));
    let _profitability = parseInt(localStorage.getItem("profitability"));
    let _mutualism = parseInt(localStorage.getItem("mutualism"));
    let _individualism = parseInt(localStorage.getItem("individualism"));

    // Purpose & Connectivity
    let purposeResult = _purpose + purposeScale;
    if (purposeConnectivity == "100/0") {
      purposeResult *= 1.5;
    }
    if (purposeConnectivity == "90/10") {
      purposeResult *= 1.4;
    }
    if (purposeConnectivity == "80/20") {
      purposeResult *= 1.3;
    }
    if (purposeConnectivity == "70/30") {
      purposeResult *= 1.2;
    }
    if (purposeConnectivity == "60/40") {
      purposeResult *= 1.1;
    }

    if (purposeResult > 10) {
      purposeResult = 10;
    }
    if (purposeResult < 0) {
      purposeResult = 0;
    }

    localStorage.setItem("purpose", JSON.stringify(purposeResult));

    let connectivityResult = _connectivity + connectivityScale;
    if (purposeConnectivity == "40/60") {
      connectivityResult *= 1.1;
    }
    if (purposeConnectivity == "30/70") {
      connectivityResult *= 1.2;
    }
    if (purposeConnectivity == "20/80") {
      connectivityResult *= 1.3;
    }
    if (purposeConnectivity == "10/90") {
      connectivityResult *= 1.4;
    }
    if (purposeConnectivity == "0/100") {
      connectivityResult *= 1.5;
    }

    if (connectivityResult > 10) {
      connectivityResult = 10;
    }
    if (connectivityResult < 0) {
      connectivityResult = 0;
    }

    localStorage.setItem("connectivity", JSON.stringify(connectivityResult));

    // Purpose & Connectivity

    // Transparency & Efficiency

    let transparencyResult = _transparency + transparencyScale;
    if (transparencyEfficiency == "100/0") {
      transparencyResult *= 1.5;
    }
    if (transparencyEfficiency == "90/10") {
      transparencyResult *= 1.4;
    }
    if (transparencyEfficiency == "80/20") {
      transparencyResult *= 1.3;
    }
    if (transparencyEfficiency == "70/30") {
      transparencyResult *= 1.2;
    }
    if (transparencyEfficiency == "60/40") {
      transparencyResult *= 1.1;
    }
    if (transparencyEfficiency == "40/60") {
      transparencyResult *= 1.1;
    }

    if (transparencyResult > 10) {
      transparencyResult = 10;
    }
    if (transparencyResult < 0) {
      transparencyResult = 0;
    }
    localStorage.setItem("transparency", JSON.stringify(transparencyResult));

    let efficiencyResult = _efficiency + efficiencyScale;
    if (transparencyEfficiency == "30/70") {
      efficiencyResult *= 1.2;
    }
    if (transparencyEfficiency == "20/80") {
      efficiencyResult *= 1.3;
    }
    if (transparencyEfficiency == "10/90") {
      efficiencyResult *= 1.4;
    }
    if (transparencyEfficiency == "0/100") {
      efficiencyResult *= 1.5;
    }

    if (efficiencyResult > 10) {
      efficiencyResult = 10;
    }
    if (efficiencyResult < 0) {
      efficiencyResult = 0;
    }
    localStorage.setItem("efficiency", JSON.stringify(efficiencyResult));
    // Transparency & Efficiency

    // Impact & Profitability

    let impactResult = _impact + impactScale;
    if (impactProfitability == "100/0") {
      impactResult *= 1.5;
    }
    if (impactProfitability == "90/10") {
      impactResult *= 1.4;
    }
    if (impactProfitability == "80/20") {
      impactResult *= 1.4;
    }
    if (impactProfitability == "70/30") {
      impactResult *= 1.2;
    }
    if (impactProfitability == "60/40") {
      impactResult *= 1.1;
    }

    if (impactResult > 10) {
      impactResult = 10;
    }
    if (impactResult < 0) {
      impactResult = 0;
    }

    localStorage.setItem("impact", JSON.stringify(impactResult));

    let profitabilityResult = _profitability + profitabilityScale;
    if (impactProfitability == "40/60") {
      profitabilityResult *= 1.1;
    }
    if (impactProfitability == "30/70") {
      profitabilityResult *= 1.2;
    }
    if (impactProfitability == "20/80") {
      profitabilityResult *= 1.3;
    }
    if (impactProfitability == "10/90") {
      profitabilityResult *= 1.4;
    }
    if (impactProfitability == "0/100") {
      profitabilityResult *= 1.5;
    }

    if (profitabilityResult > 10) {
      profitabilityResult = 10;
    }
    if (profitabilityResult < 0) {
      profitabilityResult = 0;
    }
    localStorage.setItem("profitability", JSON.stringify(profitabilityResult));

    // Impact & Profitability

    // Mutualism & Individualism

    let mutualismResult = _mutualism + mutualismScale;
    if (mutualismIndividualism == "100/0") {
      mutualismResult *= 1.5;
    }
    if (mutualismIndividualism == "90/10") {
      mutualismResult *= 1.4;
    }
    if (mutualismIndividualism == "80/20") {
      mutualismResult *= 1.3;
    }
    if (mutualismIndividualism == "70/30") {
      mutualismResult *= 1.2;
    }
    if (mutualismIndividualism == "60/40") {
      mutualismResult *= 1.1;
    }

    if (mutualismResult > 10) {
      mutualismResult = 10;
    }
    if (mutualismResult < 0) {
      mutualismResult = 0;
    }
    localStorage.setItem("mutualism", JSON.stringify(mutualismResult));

    let individualismResult = _individualism + individualismScale;
    if (mutualismIndividualism == "40/60") {
      individualismResult *= 1.1;
    }
    if (mutualismIndividualism == "30/70") {
      individualismResult *= 1.2;
    }
    if (mutualismIndividualism == "20/80") {
      individualismResult *= 1.3;
    }
    if (mutualismIndividualism == "10/90") {
      individualismResult *= 1.4;
    }
    if (mutualismIndividualism == "0/100") {
      individualismResult *= 1.5;
    }

    if (individualismResult > 10) {
      individualismResult = 10;
    }
    if (individualismResult < 0) {
      individualismResult = 0;
    }
    localStorage.setItem("individualism", JSON.stringify(individualismResult));
    // Mutualism & Individualism
  };

  const logoutUser = () => {
    setUser({ userId: null, userName: null, magicLinkAccount: null });
  };

  return (
    <>
    <Modal isOpen={isModalOpen} className='h-120 w-auto mx-40 my-40 border rounded-3xl p-3 bg-white text-center border-gray-100 shadow-lg  d-flex flex-column justify-content-space-between py-2'>
        <h2 className="font-bold text-center text-black pt-4 py-2">{modalTitle}</h2>
        <p className="text-black">{modalDescription}</p>
        <div className="d-flex justify-center py-2">
          <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => setIsModalOpen(false)}>Close</button>
        </div>
      </Modal>
      <div className="bg-header h-screen font-inter">
        <div className="px-6 pt-6 lg:px-8">
          <nav className="flex items-center justify-between">
            <div className="flex lg:flex-1">
              <a href="" className="-m-1.5 p-1.5">
                <span className="sr-only">Celium</span>
                <img
                  className="h-14"
                  src={"image/celium-white.png"}
                  alt="celium-logo"
                />
              </a>
            </div>
            <div>
              <button onClick={() => navigate("/profile")} className="mr-5">
                Profile
              </button>
              <button onClick={logoutUser}>Logout</button>
            </div>
          </nav>
        </div>

        {step === 1 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Purpose','First, purpose provides direction and focus for the development of DAOs. Without a clear sense of purpose, making decisions and prioritizing development efforts can be difficult. Individuals and entities in a DAO can work together to create more impactful and valuable projects by having a shared sense of purpose.Second, purpose can increase user engagement and interest in DAOs. When users understand the goals and objectives of a DAO, they are more likely to use it and promote it to others. This can lead to a virtuous cycle of growth and adoption as more users drive greater development and improvement of the DAO.Third, purpose can increase the trust and transparency of decentralized systems. When users understand the goals and objectives of a DAO, they are more likely to trust it and to understand how it operates. This can increase transparency and accountability, as users can see how decisions are made and resources are used.')}>Purpose</span> in a DAO to you?
                </h1>
                <div className="py-20 text-5xl">
                  <div className="w-11/12 lg:w-2/6 mx-auto">
                    <List strong insetMaterial outlineIos>
                      <BlockHeader className="text-xl font-bold">
                        {purposeScale}/10
                      </BlockHeader>
                      <ListItem
                        innerClassName="flex space-x-4"
                        innerChildren={
                          <>
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              0
                            </span>
                            <Range
                              value={purposeScale}
                              step={1}
                              min={0}
                              max={10}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                setPurposeScale(parseInt(event.target.value));
                              }}
                            />
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              10
                            </span>
                          </>
                        }
                      />
                    </List>
                  </div>
                </div>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  Are you willing to limit the DAO's ability to meet its{" "}
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Purpose','First, purpose provides direction and focus for the development of DAOs. Without a clear sense of purpose, making decisions and prioritizing development efforts can be difficult. Individuals and entities in a DAO can work together to create more impactful and valuable projects by having a shared sense of purpose.Second, purpose can increase user engagement and interest in DAOs. When users understand the goals and objectives of a DAO, they are more likely to use it and promote it to others. This can lead to a virtuous cycle of growth and adoption as more users drive greater development and improvement of the DAO.Third, purpose can increase the trust and transparency of decentralized systems. When users understand the goals and objectives of a DAO, they are more likely to trust it and to understand how it operates. This can increase transparency and accountability, as users can see how decisions are made and resources are used.')}>Purpose</span> to be more
                  connected in the web3 ecosystem?
                </h2>
                <button
                  className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setPurpose(-2);
                    handleNext();
                  }}
                >
                  Yes
                </button>
                <button
                  className="bg-white hover:bg-blue-400 hover:shadow-lg text-black hover:text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setPurpose(0);
                    handleNext();
                  }}
                >
                  No
                </button>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Connectivity','First, connectivity helps to increase interoperability and collaboration in decentralized systems and applications. By enabling decentralized applications and systems to interact with each other and share data and assets, connectivity can help to increase collaboration and innovation in the ecosystem. This can help to create a more dynamic and interrelated ecosystem where people are able to access a wider range of goods, services, and information.Second, connectivity can increase the overall web3 ecosystem by allowing for the seamless transfer of value and information across different decentralized platforms and applications. This can help to create a more unified and cohesive web3 ecosystem where users are able to easily access and utilize a wide range of decentralized tools and services.Third, connectivity can increase security and resilience in decentralized systems. By enabling decentralized applications and systems to share data and assets, and by reducing the risk of single points of failure, connectivity can increase security and resilience in decentralized systems. This can help to ensure that decentralized systems are able to withstand potential attacks or disruptions and to continue to function even in the face of challenges.')}>Connectivity</span> in a DAO to
                  you?
                </h1>
                <div className="py-20 text-5xl">
                  <div className="w-11/12 lg:w-2/6 mx-auto">
                    <List strong insetMaterial outlineIos>
                      <BlockHeader className="text-xl font-bold">
                        {connectivityScale}/10
                      </BlockHeader>
                      <ListItem
                        innerClassName="flex space-x-4"
                        innerChildren={
                          <>
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              0
                            </span>
                            <Range
                              value={connectivityScale}
                              step={1}
                              min={0}
                              max={10}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                setConnectivityScale(
                                  parseInt(event.target.value)
                                );
                              }}
                            />
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              10
                            </span>
                          </>
                        }
                      />
                    </List>
                  </div>
                </div>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  Are you willing to reduce the DAO’s ecosystem connections to
                  meet its purpose better?
                </h2>
                <button
                  className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setConnectivity(-2);
                    handleNext();
                  }}
                >
                  Yes
                </button>
                <button
                  className="bg-white hover:bg-blue-400 hover:shadow-lg text-black hover:text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setConnectivity(0);
                    handleNext();
                  }}
                >
                  No
                </button>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Connectivity','First, connectivity helps to increase interoperability and collaboration in decentralized systems and applications. By enabling decentralized applications and systems to interact with each other and share data and assets, connectivity can help to increase collaboration and innovation in the ecosystem. This can help to create a more dynamic and interrelated ecosystem where people are able to access a wider range of goods, services, and information.Second, connectivity can increase the overall web3 ecosystem by allowing for the seamless transfer of value and information across different decentralized platforms and applications. This can help to create a more unified and cohesive web3 ecosystem where users are able to easily access and utilize a wide range of decentralized tools and services.Third, connectivity can increase security and resilience in decentralized systems. By enabling decentralized applications and systems to share data and assets, and by reducing the risk of single points of failure, connectivity can increase security and resilience in decentralized systems. This can help to ensure that decentralized systems are able to withstand potential attacks or disruptions and to continue to function even in the face of challenges.')}>Connectivity</span> in a DAO to
                  you?
                </h1>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  If Purpose & Connectivity of a DAO are on a sliding scale,
                  what point on the line below represents the ideal balance to
                  you?
                </h2>
                <div className="mt-4">
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("100/0");
                      handleNext();
                    }}
                  >
                    100/0
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("90/10");
                      handleNext();
                    }}
                  >
                    90/10
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("80/20");
                      handleNext();
                    }}
                  >
                    80/20
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("70/30");
                      handleNext();
                    }}
                  >
                    70/30
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("60/40");
                      handleNext();
                    }}
                  >
                    60/40
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("50/50");
                      handleNext();
                    }}
                  >
                    50/50
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("40/60");
                      handleNext();
                    }}
                  >
                    40/60
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("30/70");
                      handleNext();
                    }}
                  >
                    30/70
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("20/80");
                      handleNext();
                    }}
                  >
                    20/80
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("10/90");
                      handleNext();
                    }}
                  >
                    10/90
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setPurposeConnectivity("0/100");
                      handleNext();
                    }}
                  >
                    0/100
                  </button>
                </div>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 4 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Transparency','First, transparency helps to increase trust and accountability in DAOs. By making information and data openly available, members are able to see how decisions are made and how resources are being used. This can help to build trust in the DAO and increase the overall credibility of the ecosystem.Second, transparency can help to prevent and address malicious activity in DAOs. By making information and data openly available, members are able to identify and address potential security risks and vulnerabilities, and to hold individuals and entities accountable for their actions. This can help to ensure that DAOs are secure and trustworthy, and to protect the interests of all members.Third, transparency can facilitate collaboration and innovation in DAOs. When information and data is openly available, individuals and entities are able to contribute their time and resources to the development and improvement of the DAO. This can increase the rate of innovation and lead to the creation of more impactful and valuable projects.')}>Transparency</span> in a DAO to
                  you?
                </h1>
                <div className="py-20 text-5xl">
                  <div className="w-11/12 lg:w-2/6 mx-auto">
                    <List strong insetMaterial outlineIos>
                      <BlockHeader className="text-xl font-bold">
                        {transparencyScale}/10
                      </BlockHeader>
                      <ListItem
                        innerClassName="flex space-x-4"
                        innerChildren={
                          <>
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              0
                            </span>
                            <Range
                              value={transparencyScale}
                              step={1}
                              min={0}
                              max={10}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                setTransparencyScale(
                                  parseInt(event.target.value)
                                );
                              }}
                            />
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              10
                            </span>
                          </>
                        }
                      />
                    </List>
                  </div>
                </div>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  Are you willing to reduce efficiency in a DAO to maintain more
                  transparency?
                </h2>
                <button
                  className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setTransparency(-2);
                    handleNext();
                  }}
                >
                  Yes
                </button>
                <button
                  className="bg-white hover:bg-blue-400 hover:shadow-lg text-black hover:text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setTransparency(0);
                    handleNext();
                  }}
                >
                  No
                </button>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 5 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('Efficiency','First, efficiency helps to reduce costs and increase accessibility in DAOs. By removing intermediaries and streamlining processes, DAOs can reduce the cost of transactions and increase accessibility to goods, services, and information. This can help to make DAOs more accessible to a broader range of users and to increase overall adoption and usage.Secondly, efficiency can increase the speed and responsiveness of DAOs. Removing intermediaries and streamlining processes, transactions, and interactions can occur more quickly and effectively. This can make DAOs more useful and valuable to people and drive the ecosystems growth and adoption.Thirdly, efficiency can help to optimize resource utilization and increase scalability in DAOs. By reducing overhead and inefficiencies, DAOs can more effectively allocate resources and scale to meet the needs of a growing membership. This can help to ensure that DAOs are sustainable and scalable and can provide the foundation for continued growth and development.')}>Efficiency</span> in a DAO to you?
                </h1>
                <div className="py-20 text-5xl">
                  <div className="w-11/12 lg:w-2/6 mx-auto">
                    <List strong insetMaterial outlineIos>
                      <BlockHeader className="text-xl font-bold">
                        {efficiencyScale}/10
                      </BlockHeader>
                      <ListItem
                        innerClassName="flex space-x-4"
                        innerChildren={
                          <>
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              0
                            </span>
                            <Range
                              value={efficiencyScale}
                              step={1}
                              min={0}
                              max={10}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                setEfficiencyScale(
                                  parseInt(event.target.value)
                                );
                              }}
                            />
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              10
                            </span>
                          </>
                        }
                      />
                    </List>
                  </div>
                </div>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  Are you willing to decrease the transparency in a DAO for it
                  to be more efficient?
                </h2>
                <button
                  className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setEfficiency(-2);
                    handleNext();
                  }}
                >
                  Yes
                </button>
                <button
                  className="bg-white hover:bg-blue-400 hover:shadow-lg text-black hover:text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setEfficiency(0);
                    handleNext();
                  }}
                >
                  No
                </button>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 6 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('Efficiency','First, efficiency helps to reduce costs and increase accessibility in DAOs. By removing intermediaries and streamlining processes, DAOs can reduce the cost of transactions and increase accessibility to goods, services, and information. This can help to make DAOs more accessible to a broader range of users and to increase overall adoption and usage.Secondly, efficiency can increase the speed and responsiveness of DAOs. Removing intermediaries and streamlining processes, transactions, and interactions can occur more quickly and effectively. This can make DAOs more useful and valuable to people and drive the ecosystems growth and adoption.Thirdly, efficiency can help to optimize resource utilization and increase scalability in DAOs. By reducing overhead and inefficiencies, DAOs can more effectively allocate resources and scale to meet the needs of a growing membership. This can help to ensure that DAOs are sustainable and scalable and can provide the foundation for continued growth and development.')}>Efficiency</span> in a DAO to you?
                </h1>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  If Transparency & Efficiency of a DAO are on a sliding scale,
                  what point on the line below represents the ideal balance to
                  you?
                </h2>
                <div className="mt-4">
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("100/0");
                      handleNext();
                    }}
                  >
                    100/0
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("90/10");
                      handleNext();
                    }}
                  >
                    90/10
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("80/20");
                      handleNext();
                    }}
                  >
                    80/20
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("70/30");
                      handleNext();
                    }}
                  >
                    70/30
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("60/40");
                      handleNext();
                    }}
                  >
                    60/40
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("50/50");
                      handleNext();
                    }}
                  >
                    50/50
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("40/60");
                      handleNext();
                    }}
                  >
                    40/60
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("30/70");
                      handleNext();
                    }}
                  >
                    30/70
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("20/80");
                      handleNext();
                    }}
                  >
                    20/80
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("10/90");
                      handleNext();
                    }}
                  >
                    10/90
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setTransparencyEfficiency("0/100");
                      handleNext();
                    }}
                  >
                    0/100
                  </button>
                </div>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 7 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is it to you that a DAO
                  creates Social and/or Environmental Impact?
                </h1>
                <div className="py-20 text-5xl">
                  <div className="w-11/12 lg:w-2/6 mx-auto">
                    <List strong insetMaterial outlineIos>
                      <BlockHeader className="text-xl font-bold">
                        {impactScale}/10
                      </BlockHeader>
                      <ListItem
                        innerClassName="flex space-x-4"
                        innerChildren={
                          <>
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              0
                            </span>
                            <Range
                              value={impactScale}
                              step={1}
                              min={0}
                              max={10}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                setImpactScale(parseInt(event.target.value));
                              }}
                            />
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              10
                            </span>
                          </>
                        }
                      />
                    </List>
                  </div>
                </div>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  Are you willing to decrease the impact of a DAO so it can be
                  more profitable?
                </h2>
                <button
                  className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setImpact(-2);
                    handleNext();
                  }}
                >
                  Yes
                </button>
                <button
                  className="bg-white hover:bg-blue-400 hover:shadow-lg text-black hover:text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setImpact(0);
                    handleNext();
                  }}
                >
                  No
                </button>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 8 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Profitability','First, profitability can provide incentives for developing and improving DAOs and their applications. The potential for financial reward can incentivize the members to contribute their time and resources to developing these systems. This can lead to faster and more impactful development, as individuals are motivated to create and improve the DAO that can generate revenue.Second, profitability can increase the sustainability of a DAO. Decentralized systems rely on the contributions of a network of individuals and entities. The ability to generate revenue can help ensure that these individuals continue contributing their time and resources. This can increase the long-term sustainability of the DAO, as they are less dependent on external funding and can generate revenue from their operations.')}>Profitability</span> in a DAO to
                  you?
                </h1>
                <div className="py-20 text-5xl">
                  <div className="w-11/12 lg:w-2/6 mx-auto">
                    <List strong insetMaterial outlineIos>
                      <BlockHeader className="text-xl font-bold">
                        {profitabilityScale}/10
                      </BlockHeader>
                      <ListItem
                        innerClassName="flex space-x-4"
                        innerChildren={
                          <>
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              0
                            </span>
                            <Range
                              value={profitabilityScale}
                              step={1}
                              min={0}
                              max={10}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                setProfitabilityScale(
                                  parseInt(event.target.value)
                                );
                              }}
                            />
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              10
                            </span>
                          </>
                        }
                      />
                    </List>
                  </div>
                </div>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  Are you willing to limit profitability in a DAO so it can
                  create more impact?
                </h2>
                <button
                  className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setProfitability(-2);
                    handleNext();
                  }}
                >
                  Yes
                </button>
                <button
                  className="bg-white hover:bg-blue-400 hover:shadow-lg text-black hover:text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setProfitability(0);
                    handleNext();
                  }}
                >
                  No
                </button>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 9 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Profitability','First, profitability can provide incentives for developing and improving DAOs and their applications. The potential for financial reward can incentivize the members to contribute their time and resources to developing these systems. This can lead to faster and more impactful development, as individuals are motivated to create and improve the DAO that can generate revenue.Second, profitability can increase the sustainability of a DAO. Decentralized systems rely on the contributions of a network of individuals and entities. The ability to generate revenue can help ensure that these individuals continue contributing their time and resources. This can increase the long-term sustainability of the DAO, as they are less dependent on external funding and can generate revenue from their operations.')}>Profitability</span> in a DAO to
                  you?
                </h1>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  If Impact & Profitability of a DAO are on a sliding scale,
                  what point on the line below represents the ideal balance to
                  you?
                </h2>
                <div className="mt-4">
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("100/0");
                      handleNext();
                    }}
                  >
                    100/0
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("90/10");
                      handleNext();
                    }}
                  >
                    90/10
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("80/20");
                      handleNext();
                    }}
                  >
                    80/20
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("70/30");
                      handleNext();
                    }}
                  >
                    70/30
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("60/40");
                      handleNext();
                    }}
                  >
                    60/40
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("50/50");
                      handleNext();
                    }}
                  >
                    50/50
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("40/60");
                      handleNext();
                    }}
                  >
                    40/60
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("30/70");
                      handleNext();
                    }}
                  >
                    30/70
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("20/80");
                      handleNext();
                    }}
                  >
                    20/80
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("10/90");
                      handleNext();
                    }}
                  >
                    10/90
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setImpactProfitability("0/100");
                      handleNext();
                    }}
                  >
                    0/100
                  </button>
                </div>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 10 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Mutualism','Mutualism emphasizes the reciprocal and cooperative nature of DAOs. In a mutualistic relationship, multiple parties work together to achieve shared benefits, rather than simply serving their own interests.Mutualism can help to increase collaboration and innovation in DAOs. By creating a shared understanding and commitment to mutual benefits, mutualism can help to foster a more cooperative environment where members are able to access a wider range of goods, services, and information. Moreover, mutualism can help increase DAOs sustainability and resilience. By emphasizing reciprocity and cooperation, mutualism can help to create more equitable and sustainable relationships between members, reducing the risk of single points of failure and promoting long-term stability.Finally, mutualism can help to increase the overall security of DAOs. By creating a shared understanding and commitment to mutual benefits,  it reduces the risk of malicious actors or attacks, ensuring that DAOs remain secure and functional even in the face of challenges.')}>Mutualism</span> in a DAO to you?
                </h1>
                <div className="py-20 text-5xl">
                  <div className="w-11/12 lg:w-2/6 mx-auto">
                    <List strong insetMaterial outlineIos>
                      <BlockHeader className="text-xl font-bold">
                        {mutualismScale}/10
                      </BlockHeader>
                      <ListItem
                        innerClassName="flex space-x-4"
                        innerChildren={
                          <>
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              0
                            </span>
                            <Range
                              value={mutualismScale}
                              step={1}
                              min={0}
                              max={10}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                setMutualismScale(parseInt(event.target.value));
                              }}
                            />
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              10
                            </span>
                          </>
                        }
                      />
                    </List>
                  </div>
                </div>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  Are you willing to decrease the mutualistic values of a DAO to
                  increase the individualistic opportunities for its members?
                </h2>
                <button
                  className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setMutualism(-2);
                    handleNext();
                  }}
                >
                  Yes
                </button>
                <button
                  className="bg-white hover:bg-blue-400 hover:shadow-lg text-black hover:text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setMutualism(0);
                    handleNext();
                  }}
                >
                  No
                </button>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 11 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Individualism','First, individualism helps to empower individuals and increase personal autonomy in DAOs. By enabling members to control their investments and interactions directly, DAOs can help to reduce the influence of intermediaries and increase personal autonomy. This can help to create a more democratic and equitable ecosystem where individuals have greater control over their lives.Second, individualism can foster innovation and creativity in DAOs. By enabling individuals to participate directly in the creation and development of the organization, the ecosystem can benefit from the members diverse perspectives and experiences. This can lead to the creation of more innovative and impactful projects tailored to members needs and preferences.Third, individualism can help to protect privacy and security in DAOs. By enabling individuals to control their investments and interactions directly, DAOs can reduce the risk of data breaches and increase privacy. This can help to ensure that members maintain control over their personal reputation and interests.')}>Individualism</span> in a DAO toyou?
                </h1>
                <div className="py-20 text-5xl">
                  <div className="w-11/12 lg:w-2/6 mx-auto">
                    <List strong insetMaterial outlineIos>
                      <BlockHeader className="text-xl font-bold">
                        {individualismScale}/10
                      </BlockHeader>
                      <ListItem
                        innerClassName="flex space-x-4"
                        innerChildren={
                          <>
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              0
                            </span>
                            <Range
                              value={individualismScale}
                              step={1}
                              min={0}
                              max={10}
                              onChange={(
                                event: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                setIndividualismScale(
                                  parseInt(event.target.value)
                                );
                              }}
                            />
                            <span
                              className="text-xl"
                              style={{ lineHeight: "4rem" }}
                            >
                              10
                            </span>
                          </>
                        }
                      />
                    </List>
                  </div>
                </div>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  Are you willing to limit the individualistic opportunities for
                  members to create a more mutualist DAO?
                </h2>
                <button
                  className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setIndividualism(-2);
                    handleNext();
                  }}
                >
                  Yes
                </button>
                <button
                  className="bg-white hover:bg-blue-400 hover:shadow-lg text-black hover:text-white font-bold py-3 px-20 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  onClick={() => {
                    setIndividualism(0);
                    handleNext();
                  }}
                >
                  No
                </button>
                <div>
                  <button
                    onClick={handleNext}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {step === 12 && (
          <div className="container mx-auto">
            <div className="sm:flex flex-row ">
              <div className="text-center md:p-20 py-8">
                <h1 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  On a scale of 1-10, how important is the value of &nbsp;
                  <span className="underline cursor-pointer" onClick={() => passValue('The Value of Individualism','First, individualism helps to empower individuals and increase personal autonomy in DAOs. By enabling members to control their investments and interactions directly, DAOs can help to reduce the influence of intermediaries and increase personal autonomy. This can help to create a more democratic and equitable ecosystem where individuals have greater control over their lives.Second, individualism can foster innovation and creativity in DAOs. By enabling individuals to participate directly in the creation and development of the organization, the ecosystem can benefit from the members diverse perspectives and experiences. This can lead to the creation of more innovative and impactful projects tailored to members needs and preferences.Third, individualism can help to protect privacy and security in DAOs. By enabling individuals to control their investments and interactions directly, DAOs can reduce the risk of data breaches and increase privacy. This can help to ensure that members maintain control over their personal reputation and interests.')}>Individualism</span> in a DAO to
                  you?
                </h1>
                <h2 className="text-5xl font-bold tracking-tight text-white sm:text-5xl font-inter">
                  If Mutualism & Individualism of a DAO are on a sliding scale,
                  what point on the line below represents the ideal balance to
                  you?
                </h2>
                <div className="mt-4">
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("100/0");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    100/0
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("90/10");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    90/10
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("80/20");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    80/20
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("70/30");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    70/30
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("60/40");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    60/40
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("50/50");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    50/50
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("40/60");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    40/60
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("30/70");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    30/70
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("20/80");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    20/80
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("10/90");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    10/90
                  </button>
                  <button
                    className="bg-blue-400 hover:bg-purple-500 hover:shadow-lg text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl my-1 mx-1"
                    onClick={() => {
                      setMutualismIndividualism("0/100");
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                  >
                    0/100
                  </button>
                </div>
                <div>
                  <button
                    onClick={() => {
                      calculateParing();
                      calculateScaling();
                      handleNext();
                    }}
                    className="bg-purple-500 hover:bg-purple-600 text-white font-bold py-3 px-10 focus:outline-none focus:shadow-outline rounded-3xl text-2xl mt-12 mx-3"
                  >
                    Next Question
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Questions;
